
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionHandlerDirective } from '../../directives/subscription-handler.directive';
import { SupportData } from '../../models/support.models';

@Component({
    selector: 'app-chat-support-link',
    templateUrl: './chat-support-link.component.html',
    styleUrls: ['./chat-support-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatSupportLinkComponent extends SubscriptionHandlerDirective {
    @Input() supportData: SupportData;

    constructor() {
        super();
    }
}
